import { DateTime } from 'luxon'

export function optionalDate(date: Date | undefined): DateTime | undefined {
  return date !== undefined ? DateTime.fromJSDate(date) : undefined
}
